// Third party components
// Custom components
import { environment } from "../../../environments/environment";
import * as i0 from "@angular/core";
var EnvironmentService = /** @class */ (function () {
    function EnvironmentService() {
    }
    /**
     * Class constructor
     */
    // constructor() {}
    /**
     * Get the API URL for current environment
     *
     * @since 1.0.0
     */
    EnvironmentService.prototype.getApiUrl = function (version) {
        if (version === void 0) { version = environment.apiVersion; }
        var url = "" + environment.apiProtocol + environment.apiHost + "/api/" + version;
        if (environment.apiPort) {
            url = "" + environment.apiProtocol + environment.apiHost + ":" + environment.apiPort + "/api/" + version;
        }
        return url;
    };
    /**
     * Get the Suppliers API URL for current environment
     *
     * @since 1.0.0
     */
    EnvironmentService.prototype.getSuppliersApiUrl = function () {
        var url = "" + environment.suppliersApiProtocol + environment.suppliersApiHost + "/api/" + environment.suppliersApiVersion;
        if (environment.suppliersApiPort) {
            url = "" + environment.suppliersApiProtocol + environment.suppliersApiHost + ":" + environment.suppliersApiPort + "/api/" + environment.suppliersApiVersion;
        }
        return url;
    };
    /**
     * Get current env front-end host
     *
     * @since 1.0.0
     */
    EnvironmentService.prototype.getFrontEndHost = function () {
        return "" + environment.frontEndHost;
    };
    /**
     * Get current config for cookie secure flat
     *
     * @since 1.0.0
     */
    EnvironmentService.prototype.getFrontEndCookieSecure = function () {
        return environment.cookieSecure;
    };
    EnvironmentService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function EnvironmentService_Factory() { return new EnvironmentService(); }, token: EnvironmentService, providedIn: "root" });
    return EnvironmentService;
}());
export { EnvironmentService };
